import { apiRequestHandlerPromise } from 'utils/apiRequestHandler';

export const fetchFormatExtensions = () => {
  return apiRequestHandlerPromise<Record<string, string>>({
    url: `format_extensions`,
    method: 'GET',
  });
};
